import React from 'react';
import Cover from "../../components/Cover";
import './index.sass';
import About from "./about";
import Work from "./work";
import Waves from "../../components/Waves";
import Contact from "./contact";

function Index({cursor}) {
    return (
        <>
            <Cover />

            <Waves pos={'top'} />

            <section id="about">
                <About />
            </section>

            <section id="work">
                <Work cursor={cursor} />
            </section>

            <Waves pos={'bottom'} />

            <section id="contact">
                <Contact />
            </section>
        </>
    );
}

export default Index;